<template>
    <div>
        <v-container v-if="!meeting || meeting.status == 'ended'">
            <v-alert type="info">You are not currently in a meeting! <router-link to="/main" class="white--text">Click here</router-link> to go home.</v-alert>
        </v-container>
        <v-container v-if="meeting && meeting.status == 'awaiting_participants'">
            <h1>Waiting for participants...</h1>

            <p>All of the participants must accept the meeting invitation for the meeting to start.</p>

            <v-card outlined class="my-4">
                <v-card-title>Participants</v-card-title>
                <v-list-item v-for="p in meeting.participants" :key="p.id">
                    <v-list-item-avatar>
                        <v-avatar :color="p.accepted ? 'green' : 'orange'">
                            <span class="white--text headline">{{ avatarText(p) }}</span>
                        </v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>{{ p.name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ p.role.name }} - <span :class="p.accepted ? 'green--text' : 'orange--text'">{{ p.accepted ? "Accepted" : "Waiting for response..." }}</span></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-card>
        </v-container>
        <v-container v-if="meeting && meeting.status == 'in_progress'" style="height: 100%;">
            <v-card outlined color="secondary">
                <v-card-text class="text-center white--text" style="font-size: 1.2em;">
                    Meeting ends in {{ meetingEnd }}
                </v-card-text>
            </v-card>
            <v-row style="height: 100%;">
                <v-col cols="12" md="8">
                    <v-card outlined style="height: 100%; max-height: 80vh; min-height: 80vh;" class="d-flex flex-column">
                        <v-card-title>
                            Chat
                        </v-card-title>
                        <div id="message-box" class="flex-grow-1" style="overflow-y: scroll;">
                            <v-list-item>
                                <v-list-item-avatar>
                                    <v-avatar color="secondary">
                                        <v-icon color="white">mdi-robot</v-icon>
                                    </v-avatar>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title style="font-size: 1.2em;">
                                        <b>Meeting Bot</b>
                                    </v-list-item-title>
                                    <span>
                                        Welcome to your meeting! You have {{ meetingEnd }} to discuss the topic of your
                                        meeting which is <span class="red--text">"{{ meeting.topic }}"</span>
                                    </span>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-for="msg in messages" :key="msg.id">
                                <v-list-item-avatar>
                                    <v-avatar color="primary">
                                        <span class="white--text headline">{{ avatarText(msg.sender) }}</span>
                                    </v-avatar>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title style="font-size: 1.2em;">
                                        <b>{{ msg.sender.name }}</b> <v-chip small color="secondary">{{ msg.sender.role }}</v-chip>
                                    </v-list-item-title>
                                    <span>
                                        {{ msg.content }}
                                    </span>
                                </v-list-item-content>
                            </v-list-item>
                        </div>
                        <v-card-text>
                            <v-text-field v-model="message" label="Message" type="text" append-outer-icon="mdi-send" @click:append-outer="sendMessage()" @keyup.enter="sendMessage()" outlined></v-text-field>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="4">
                    <v-card outlined class="mb-4">
                        <v-card-title>Participants</v-card-title>
                        <v-list-item v-for="p in meeting.participants" :key="p.id">
                            <v-list-item-avatar>
                                <v-avatar color="primary">
                                    <span class="white--text headline">{{ avatarText(p) }}</span>
                                </v-avatar>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ p.name }}</v-list-item-title>
                                <v-list-item-subtitle>{{ p.role.name }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>

                    <v-card outlined>
                        <v-card-title>Information</v-card-title>
                        <!-- <v-list-item>
                            <v-list-item-content>
                                Meeting ends in
                            </v-list-item-content>
                            <v-list-item-action-text>
                                {{ meetingEnd }}
                            </v-list-item-action-text>
                        </v-list-item> -->
                        <v-list-item>
                            <v-list-item-content>
                                Topic
                            </v-list-item-content>
                            <v-list-item-action-text>
                                {{ meeting.topic }}
                            </v-list-item-action-text>
                        </v-list-item>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    data: () => ({
        message: "",
        meetingEnd: "? seconds",
        timerInterval: null
    }),
    computed: {
        ...mapState({
            meeting: state => state.meeting,
            messages: state => state.meeting?.messages || []
        })
    },
    methods: {
        scrollToBottom() {
            this.$log.debug("Scrolling down!");
            var messageDiv = document.getElementById("message-box");
            if (messageDiv) {
                messageDiv.scrollTop = messageDiv.scrollHeight;
            }
        },
        avatarText(p) {
            return p.name.charAt(0);
        },
        sendMessage() {
            this.message = this.message.trim();

            if (this.message == "") { return; }

            this.$socket.client.emit("send_message", {
                content: this.message,
                type: "meeting",
                meeting: this.meeting.id
            });

            this.message = "";
        },
        updateTimer() {
            if (!this.meeting) { return; }
            if (this.meeting.status != "in_progress") { return; }

            var diff = new Date(this.meeting.endsAt) - new Date();
            var secondsDiff = Math.floor(diff / 1000);

            this.meetingEnd = `${secondsDiff} seconds`;

            if (this.meeting && secondsDiff < 0) {
                this.endMeeting();

                if (this.timerInterval) {
                    clearInterval(this.timerInterval);
                }
            }
        },
        endMeeting() {
            this.$log.debug("Ending meeting...");
            this.$socket.client.emit("meeting", {
                action: "end",
                id: this.meeting.id
            });
        }
    },
    watch: {
        messages() {
            setTimeout(this.scrollToBottom, 250);
        }
    },
    mounted() {
        this.scrollToBottom();
        this.updateTimer();
        this.timerInterval = setInterval(this.updateTimer, 1000);
    }
}
</script>
